<template>
            <div class="content">
              <div class="row ">
                <div class="col-1"></div>
                <div class="col ">
                  <div class="card card-user">
              <div class="card-header">
                <h5 class="card-title">FİRMA DÜZENLEME</h5>
              </div>
              <div class="card-body">
                <form @submit.prevent="onSubmit">
                  <hr>
                   
                  <h5>FİRMA BİLGİLERİ</h5>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>FİRMA ADI</label>
                        <input v-model="firma.adi"   type="text" class="form-control" value="dasd">
                      </div>
                    </div>      
                  </div>
                  <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>SEKTÖR</label>
                        <select v-model="firma.sektor" class="custom-select">
                          <option value="MEDİKAL">MEDİKAL</option>
                          <option value="SAVUNMA">SAVUNMA</option>
                          <option value="MAKİNE">MAKİNE</option>
                          <option value="E.ELEKTRONİK">E.ELEKTRONİK</option>
                          <option value="REKLAM TASARIM">REKLAM TASARIM</option>
                          <option value="MİMARLIK">MİMARLIK</option>
                          <option value="YAZILIM">YAZILIM</option>
                          <option value="DİĞER">DİĞER</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6 pl-1">
                      <div class="form-group">
                        <label>KONTENJAN</label>
                        <input  v-model="firma.kontenjan" class="form-control" type="number" >
                      </div>
                    </div>
                  </div>


                  <hr>
                  <h5>İLETİŞİM BİLGİLERİ</h5>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>FİRMADAKİ İLGİLİ</label>
                        <input v-model="firma.ilgili"  type="text" class="form-control" placeholder="Firmadaki İlgili" >
                      </div>
                    </div>      
                  </div>

                  <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>TELEFON</label>
                        <input v-model="firma.telefon"  type="text" class="form-control" placeholder="0(500) XXX XX XX" >
                      </div>
                    </div>
                    <div class="col-md-6 pl-1">
                      <div class="form-group">
                        <label>E Posta</label>
                        <input v-model="firma.eposta"  type="text" class="form-control" placeholder="E Posta" >
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>ADRES</label>
                        <textarea v-model="firma.adres"  class="form-control textarea"></textarea>
                      </div>
                    </div>      
                  </div>


                
                  <hr>
                  <h5>İLGİLİ AKADEMİSYEN</h5>
                    <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>AKADEMİSYEN ADI</label>
                        <input v-model="firma.akademisyenAdi"  type="text" class="form-control" placeholder="Akademisyenin Adı" >
                      </div>
                    </div>      
                  </div>
                   <h5>ÜRÜN HİZMET DETAYLARI</h5>
                     <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>ÜRÜNLER</label>
                        <input v-model="firma.urunler"  type="text" class="form-control" placeholder="" >
                      </div>
                    </div>      
                  </div>
                   <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>PARKURLAR</label>
                        <input v-model="firma.parkurlar"  type="text" class="form-control" placeholder="" >
                      </div>
                    </div>      
                  </div>
                   <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>SERTİFİKASYONLAR</label>
                        <input v-model="firma.sertifikasyonlar"   type="text" class="form-control" placeholder="" >
                      </div>
                    </div>      
                  </div>
                  <h5>PERSONEL NİTELİĞİ</h5>
                     <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>DOKTORA</label>
                        <input v-model="firma.doktora"  type="number" class="form-control" placeholder="" >
                      </div>
                    </div>      
                  </div>
                   <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>YÜKSEK LİSANS</label>
                        <input v-model="firma.yukseklisans"   type="number" class="form-control" placeholder="" >
                      </div>
                    </div>      
                  </div>
                   <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>LİSANS</label>
                        <input v-model="firma.lisans"  type="number" class="form-control" placeholder="" >
                      </div>
                    </div>      
                  </div>
                  <h5>İSTİSNAİ DURUMLAR</h5>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <textarea v-model="firma.istisna"  class="form-control textarea"></textarea>
                      </div>
                    </div>      
                  </div>
                
                  <div class="row">
                    <div class="update ml-auto mr-auto">
                      <button @click="goToBack"   class="btn btn-warning btn-round">Vazgeç</button>
                      <button @click="editCompany" class="btn btn-success btn-round">Güncelle</button>
                    </div>
                  </div>
                </form>
              </div>
              
            </div>
                </div>
                <div class="col-1"></div>
              </div>
            </div>
</template>

<script>
import { mapGetters} from "vuex";

export default {
    computed : {
      ...mapGetters(["getCompany","getSelectedCompany","getStudents","getselectedStudentList"])
    },
  data (){
      return {
        firma : {
            adi : "",
            sektor : "",
            kontenjan : null,
            ilgili : "",
            telefon : "",
            eposta : "",
            adres : "",
            akademisyenAdi : "",
            urunler : "",
            parkurlar : "",
            sertifikasyonlar : "",
            doktora : null,
            yukseklisans : null,
            lisans : null,
            istisna : "",
            ogrencilistesi : "",
           
        }
      }
    },
    methods : {
      editCompany(i){        
        this.$store.dispatch("editCompany", this.firma);
        this.goToBack();
      },
      goToBack(){
        this.buttonClicked = true
        this.$router.push("/company")
      },
      
    },
    created(){
         this.firma = this.getCompany[this.getSelectedCompany]
        
      }
    
}
</script>


// WEBPACK FOOTER //
// src/components/company/CompanyEdit.vue